
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"70","height":"70","fill":"none","viewBox":"0 0 70 70"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"35","cy":"35","r":"35","fill":"#25D366"}}),_c('g',{attrs:{"clip-path":"url(#whatsapp_svg__clip0)"}},[_c('path',{attrs:{"fill":"#fff","d":"M35 19.113A14.999 14.999 0 0020 34a14.67 14.67 0 002.675 8.462l-1.688 5a.634.634 0 00.15.638.637.637 0 00.638.162l5.25-1.662a15.014 15.014 0 007.533 2.29A14.998 14.998 0 0050 34a15 15 0 00-15-14.888zm9 20.9a4.887 4.887 0 01-4.375 2.612 13.352 13.352 0 01-4.313-1.25 17.504 17.504 0 01-7.437-6.45c-2.387-3.162-2.5-6.125-.2-8.575a2.705 2.705 0 012.325-.7 1.929 1.929 0 011.513 1.088l.474 1.15.788 1.887a1.374 1.374 0 010 1.25 6.407 6.407 0 01-1.25 1.712c.642.978 1.393 1.88 2.238 2.688a11.321 11.321 0 003.412 2.038c.35-.45 1.038-1.25 1.25-1.588a1.25 1.25 0 011.675-.45c.475.175 3.137 1.475 3.137 1.475.339.115.635.328.85.613a2.492 2.492 0 01-.087 2.5z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"whatsapp_svg__clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h30v30H0z","transform":"translate(20 19)"}})])])])
          )
        }
      }
    